export const userAgent = typeof window !== 'undefined' ? window.navigator?.userAgent : '';
export const iosWebView = /(iPhone|iPod|iPad|Macintosh).*AppleWebKit(?!.*Safari)/i.test(userAgent);
export const androidWebView = /.*(; wv|Version\/\d\.\d|\.0\.0\.0).*/.test(userAgent);
export const ramblerMailApp = /.*mail-native-app.*/i.test(userAgent);
export const webView = iosWebView || androidWebView || ramblerMailApp;
export const windowsPhone = /IEMobile|Windows Phone/i.test(userAgent);
export const ios = /iPhone|iPad|iPod/i.test(userAgent) && !windowsPhone;
export const android = /Android/i.test(userAgent) && !windowsPhone;
export const mobile = ios || android;
export const firefox = /Firefox/i.test(userAgent);
